import React from "react";

import { useOrgModParams } from "src/features/orgmod";

export function useValidatorOptions(): { api: { search: string } } | undefined {
	const { org, mod } = useOrgModParams();
	return React.useMemo(() => {
		if (org === "" && mod === "") {
			return undefined;
		}
		return { api: { search: `organization=${org}&module=${mod}` } };
	}, [org, mod]);
}
